module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_6000.258df8b1.png";